import { render, staticRenderFns } from "./ordersale.vue?vue&type=template&id=1125dc46&scoped=true&"
import script from "./ordersale.vue?vue&type=script&lang=js&"
export * from "./ordersale.vue?vue&type=script&lang=js&"
import style0 from "./ordersale.vue?vue&type=style&index=0&id=1125dc46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1125dc46",
  null
  
)

export default component.exports